import React, { useState } from "react";
import "../../css/components/Footer.css";
import { ReactComponent as PhoneIcon } from "../../assets/icons/phone.svg";
import { ReactComponent as MailIcon } from "../../assets/icons/mail.svg";
import { ReactComponent as LinkedInIcon } from "../../assets/icons/linkedin.svg";
import { ReactComponent as FacebookIcon } from "../../assets/icons/facebook.svg";
import { ReactComponent as LocationIcon } from "../../assets/icons/location.svg";
import mapImg from "../../assets/images/Map.jpg";
import hoverLocationImg from "../../assets/images/hover_location.png";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="footer-container">
      <footer className="footer">
        <div className="footer-main">
          <div className="footer-contact">
            <span className="help-text content-semibold">
              YOUR QUESTIONS ARE WELCOME
            </span>
            <div className="footer-title title-semibold">
              Give us a call or drop us a message
            </div>
            <hr className="footer-divider" />
            <div className="footer-info">
              <div className="footer-row">
                <PhoneIcon className="footer-icon" />
                <a className="content" href="tel:07710 059684">
                  07710 059684
                </a>
              </div>
              <div className="footer-row">
                <MailIcon className="footer-icon" />
                <a
                  className="content"
                  href="mailto:merrick@merrickplatts.co.uk"
                >
                  merrick@merrickplatts.co.uk
                </a>
              </div>
            </div>
            <div className="footer-social">
              <a
                href="https://www.linkedin.com/company/merrick-platts-financial-service/about/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon className="footer-social-icon" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61588171149921"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon className="footer-social-icon" />
              </a>
            </div>
          </div>
          <div
            className="footer-map"
            onClick={() =>
              window.open("https://maps.app.goo.gl/Qi8HBcNdYWCw1Gsc7", "_blank")
            }
          >
            <img src={mapImg} alt="Map" className="footer-map-img" />
            <div
              className="footer-location-pin-wrapper"
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >
              <LocationIcon className="footer-location-pin" />
              {hovered && (
                <img
                  src={hoverLocationImg}
                  alt="Hover Location"
                  className="footer-hover-location-img"
                />
              )}
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-legal">
        <div className="footer-legal-text">
          <span
            style={{ textDecoration: "underline", cursor: "pointer" }}
            className="content-semibold primary"
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </span>
          <br />
          Merrick Platts Financial Services Limited is an Appointed
          Representative of Rosemount Financial Solutions (IFA) Limited which is
          authorised and regulated by the Financial Conduct Authority (FCA).
          Entered on the FCA Register (https://register.fca.org.uk/) under
          reference 535515. Registered as a Limited Company in England & Wales
          No 16774781. Registered Address: 4 The Chase, Markfield, England, LE67
          9XF.<br/> The information contained within this website is subject to the
          UK regulatory regime, and is therefore targeted at consumers based in
          the UK.
        </div>
      </div>
    </div>
  );
};

export default Footer;
